// UPLOAD
export const apiUploadFile = "/quytrinh/api/v1/UploadFiles"
